import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';
import { DatabaseService } from '../providers/database.service';
import { StreamService } from '../providers/stream.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {
  streamList: any[] = [];
  selStream = {name: 'not yet'};
  constructor(public authService: AuthService, public databaseService: DatabaseService) {
    var ref = databaseService.getStreams();
    ref.on('value',
      snap => {
        var streamsObject = snap.val();
        var streamList = Object.keys(streamsObject).map(
          key => {
            return streamsObject[key];
          }
        )
        for (let stream of streamList) {
          if (stream.peerEmail === authService.email) {
            this.streamList.push(stream);
          }
        }
      });
  }

  ngOnInit() {
  }

  startPlay(obj: any) {
    this.selStream = obj;
  }

}


// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/info/info.component.ts